import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectSharesUsers = (state: RootState) => state.sharesUsers;

export const selectSharesUsersData = createSelector([selectSharesUsers], ({ data }) => data);

export const selectSharesUsersLoading = createSelector(
  [selectSharesUsers],
  ({ sharesUsersDataRequestId }) => !!sharesUsersDataRequestId,
);
